<template>
  <svg
    v-if="showPlaceholder"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 300 300"
    :title="alt"
    class="sp-img"
    part="base"
  >
    <path class="sp-img__placeholder-background" d="M0 0h300v300H0z" />

    <path
      class="sp-img__placeholder-color"
      d="M200 97H100c-1.7 0-3 1.3-3 3v100c0 1.7 1.3 3 3 3h100c1.7 0 3-1.3 3-3V100c0-1.7-1.3-3-3-3zm-3 100h-94v-94h94v94z"
    />
    <path
      class="sp-img__placeholder-color"
      d="M119.2 183.2h61.7c1.7 0 3-1.3 3-3v-22.1c0-.9-.4-1.8-1.2-2.4l-14.3-11c-1.2-.9-2.8-.8-3.9.2L146.7 162l-15.6-4.8c-1.1-.4-2.3 0-3.1.8l-11 12c-.5.5-.8 1.3-.8 2v8.2c0 1.6 1.3 3 3 3zm3-10l9-9.7 15.5 4.8c1.1.3 2.2.1 3-.7l17.1-16.5 11.1 8.5v17.6h-55.7v-4zM139.8 135.8c2.5 0 4.6-2 4.6-4.6 0-2.5-2-4.6-4.6-4.6-2.5 0-4.6 2-4.6 4.6 0 2.6 2.1 4.6 4.6 4.6z"
    />
  </svg>
  <img
    v-else
    :loading="loading"
    :src="source"
    :srcset="srcset"
    :sizes="sizes"
    :alt="alt"
    class="sp-img"
    part="base"
    @error="handleImageError"
    @load="handleImageLoad"
  />
</template>

<script setup>
import { computed, toRef } from "vue";
import { useImgFallback } from "./composables/useImgFallback";

import { props as propsDefinitions } from "./props.js";

const props = defineProps(propsDefinitions);

const source = computed(() => props.src);
const { handleImageError, handleImageLoad, showPlaceholder } = useImgFallback(toRef(props, "noPlaceholder"));
</script>

<style>
:host {
  display: block;
}
</style>

<style scoped lang="scss">
.sp-img {
  display: var(--sp-comp-img-display, inline);
  width: var(--sp-comp-img-width, auto);
  max-width: var(--sp-comp-img-max-width, none);
  height: var(--sp-comp-img-height, auto);
  object-fit: var(--sp-comp-img-object-fit, fill);
}

.sp-img__placeholder-background {
  --placeholder-background: v-bind(placeholderbackground);
  fill: var(--sp-comp-img-placeholder-background, var(--placeholder-background));
}

.sp-img__placeholder-color {
  --placeholder-color: v-bind(placeholdercolor);
  fill: var(--sp-comp-img-placeholder-color, var(--placeholder-color));
}
</style>
